import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

export interface PrimaryButton {
	text: string;
	link: string;
}
export interface PromotionTitle {
	description: string;
	imageAltText: string;
	imageUrl: string;
	promotionId: string;
	title: string;
	dateTill: string | null;
	isTimed: boolean;
	offerDefinitionId?: number | null;
	primaryButton: PrimaryButton;
	isPromoButton?: boolean;
}

export const fetchPromotionName = (promotionData: PromotionTitle) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(
			createAction(actionTypes.FETCH_PROMOTION_NAME_SUCCESS, {
				promoDetails: promotionData,
			}),
		);
	};
};
